import React from 'react';
import { useTranslate } from '@hooks';
import { getNameWithId } from '@dotone/react-ui-core/utils';
import {
  TablePaginated,
  FlexContainer,
  BasicPopover,
  AffiliateMarketplaceInviteStatusBadge as StatusBadge,
} from '@dotone/react-ui-core';
import { MarketplaceInviteFormModal as InviteFormModal } from '../Marketplace';
import { formatAffiliate, formatDateTime, formatSiteInfos } from '../formatters';
import MarketplaceInviteEmailLogModal from './MarketplaceInviteEmailLogModal';

const formatStatus = (row, { t }) => {
  const target = `invite-action-${row.id}`;

  return (
    row.status && (
      <FlexContainer column align="stretch" style={{ gap: 4, width: '100%' }}>
        <StatusBadge block value={row.status} />
        {row.reinvitable && (
          <>
            <BasicPopover
              target={target}
              content={t('marketplace:hints.reinvite.content', {
                offer: row.offer?.name,
              })}
            />
            <InviteFormModal
              defaultValues={{ affiliateId: row.affiliate?.id, offerId: row.offerId }}
              buttonProps={{
                size: 'sm',
                block: true,
                style: { width: '100%' },
                iconProps: { size: 12 },
                id: target,
                children: t('marketplace:inviteStatus.reinvite'),
              }}
            />
          </>
        )}
      </FlexContainer>
    )
  );
};

const formatSentEmailLog = (row) => (
  <MarketplaceInviteEmailLogModal affiliateMarketplaceInvite={row} />
);

const getColumns = ({ t }) => [
  {
    dataField: 'affiliateId',
    text: t('::common:model.affiliate'),
    formatter: (cell, row) => formatAffiliate(row.affiliate),
    sort: true,
  },
  {
    dataField: 'affiliate.siteInfos',
    text: t('marketplace:model.siteInfos'),
    headerStyle: {
      width: '10%',
    },
    formatter: (cell, row) =>
      cell?.length ? formatSiteInfos(cell, row.affiliate) : t('common:na'),
  },
  {
    dataField: 'id',
    text: t('sentEmailLog'),
    headerStyle: {
      width: '4%',
    },
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: (cell, row) => formatSentEmailLog(row),
  },
  {
    dataField: 'status',
    text: t('::common:model.status'),
    sort: true,
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: (cell, row) => formatStatus(row, { t }),
  },
  {
    dataField: 'createdAt',
    text: t('createdAt'),
    sort: true,
    formatter: formatDateTime,
  },
  {
    dataField: 'joinedAt',
    text: t('joinedAt'),
    formatter: formatDateTime,
  },
  {
    dataField: 'offer',
    text: t('::common:model.offer'),
    alias: 'offerId',
    sort: true,
    formatter: (cell) => getNameWithId(cell),
  },
];

const MarketplaceInviteTable = (props) => {
  const { t } = useTranslate('affiliateMarketplaceInvite', 'model');
  const columns = getColumns({ t });

  return (
    <TablePaginated
      remote
      condensed
      responsive
      hover
      classes="stylish-table text-sm"
      columns={columns}
      {...props}
    />
  );
};

export default MarketplaceInviteTable;
